import { ClearableTextField } from '@app/components/form/ClearableTextField';
import { customIdColumnHeaderMessage } from '@app/modules/audit/components/create-custom-id-column';
import { ComponentProps } from 'react';
import { useIntl } from 'react-intl';

type CustomIdFieldProps = Omit<ComponentProps<typeof ClearableTextField>, 'name' | 'label'> & {
  name?: string;
  label?: string;
};

/**
 * Shared Formik text field for filtering by material / custom ID ("ID material").
 */
export function CustomIdField({
  name = 'customId',
  submitOnClear = true,
  label,
  ...props
}: CustomIdFieldProps) {
  const { $t } = useIntl();

  return (
    <ClearableTextField
      name={name}
      submitOnClear={submitOnClear}
      label={label ?? $t(customIdColumnHeaderMessage)}
      {...props}
    />
  );
}
